
$(document).ready(function () {
    setTimeout(function () {
        $(".floating-alert").fadeOut(500);
    }, 2000);
});